import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ItemDisplay from "./ItemDisplay";

function Inventory(props) {
  const ItemList = [];
  for (const [index, value] of props.inventory.entries()) {
    ItemList.push(
      <Col lg={12/props.perRow} key={index} className="m-0 py-1 pl-3">
        <ItemDisplay
          key={index}
          index={index}
          item={value}
          equipItem={props.equipItem}
        />
      </Col>
    );
  }
  return <Row>{ItemList}</Row>;
}

export default Inventory;
